import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '~/utils/redux/hooks';
import { selectStaffFeatures, selectUser } from '~/thunks/auth/authSlice';
import { canAccessAdminRoute } from '~/utils/helper/adminAccess';
import { adminRouteAbsolute } from '~/utils/routes/admin';

type Props = {
  feature?: string;
  superAdminOnly?: boolean;
  page: ReactElement;
};

// Blocks a deep link to an admin page the account isn't granted; the Dashboard is always open.
const AdminRoute = ({ feature, superAdminOnly, page }: Props) => {
  const user = useAppSelector(selectUser);
  const staffFeatures = useAppSelector(selectStaffFeatures);

  if (!canAccessAdminRoute(user, staffFeatures, { feature, superAdminOnly })) {
    return <Navigate to={adminRouteAbsolute.dashboard} replace />;
  }

  return page;
};

export default AdminRoute;
